import React, {FC} from 'react'
import {Redirect, Route, RouteProps} from 'react-router-dom'

import {RouteEnum, RouteSpec, useRoutes} from '@progyny/routes/index'

interface AppRouteProps extends RouteProps {
  meContext: {
    hasStartedLegacyOnboarding: boolean
    isAuthorized: boolean
    loading?: boolean
    isAccountCreated?: boolean
    isLoggedIn?: boolean
  }
  routeSpec: RouteSpec
}

export const AppRoute: FC<AppRouteProps> = (props) => {
  const {meContext, routeSpec, ...rest} = props
  const {getPath} = useRoutes()
  const loginPath = getPath(RouteEnum.LOGIN)
  const nextRoute = encodeURI(window.location.pathname)
  const _rest = {
    render: routeSpec.render,
    exact: routeSpec.notExact === undefined ? true : !routeSpec.notExact,
    ...rest,
  }

  // Only check authorization if not loading
  // This prevents redirects to login when data is being refetched after mutations
  // Also allow access if user is logged in and account is created, even if isAuthorized is temporarily false
  // This handles the case where isAuthorized hasn't updated yet after completing onboarding
  const shouldAllowAccess =
    meContext.loading ||
    (meContext.isLoggedIn &&
      meContext.isAccountCreated &&
      !meContext.isAuthorized)

  if (
    routeSpec.onlyAuthorized &&
    !meContext.isAuthorized &&
    !shouldAllowAccess
  ) {
    if (meContext.hasStartedLegacyOnboarding) {
      return <Redirect to={`${getPath(RouteEnum.MIGRATE_ACCOUNT)}`} />
    } else {
      console.warn('User accessed route that should not be available')
      return <Redirect to={`${loginPath}?next=${nextRoute}`} />
    }
  }

  return <Route {..._rest} />
}
